import Elimu1 from "./Elimu1";
import Elimu2 from "./Elimu2";
import { FiArrowDownCircle } from 'react-icons/fi'
import CriticalApply from '../../assets/CriticalApply.pdf'
import CriticalClaim from '../../assets/CriticalClaim.pdf'
import { Link } from 'react-router-dom'
import ElimuBoraFile from "../../assets/ElimuBora.pdf"

const posts = [
  {
    id: 1,
    title: "What Are The Benefits Of Elimu Bora Education Plan?",
    href: "#",
    description: <Elimu1 />,
  },
  {
    id: 2,
    title: "Other optional benefits",
    href: "#",
    description: <Elimu2 />,
  },
];

export default function ElimuBora() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Elimu Bora Education Plan
          </h2>
          <p className="mt-2 text-xl leading-8 text-gray-600">
            Elimu Bora Education Plan is a combination of insurance protection
            and savings that allows you to prepare for the cost of education of
            your child. The plan has been specifically designed to provide funds
            for your child’s fees while in secondary school and a lump sum
            amount for joining university.
          </p>
        </div>
        <div className="flex gap-x-4 items-center ">
              <a
                download={CriticalApply}
                href={CriticalApply}
                className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                aria-label="Download Resume"
              >
                <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                <span className="text-sm sm:text-lg font-general-medium duration-100">
                  Application Form
                </span>
              </a>
              <a
                href={CriticalClaim}
                download={CriticalClaim}
                className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                aria-label="Download Resume"
              >
                <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                <span className="text-sm sm:text-lg font-general-medium duration-100">
                  Claim Form
                </span>
              </a>
              <a
                href={ElimuBoraFile}
                download={ElimuBoraFile}
                className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
                aria-label="Download Resume"
              >
                <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
                <span className="text-sm sm:text-lg font-general-medium duration-100">
                  Product Brochure
                </span>
              </a>
            </div>

        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {posts.map((post) => (
            <article
              key={post.id}
              className="flex max-w-xl  items-start justify-between"
            >
              <div className="flex items-center gap-x-4 text-xs"></div>
              <div className="group relative">
                <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                  <a href={post.href}>
                    <span className="absolute inset-0" />
                    {post.title}
                  </a>
                </h3>
                <p className="mt-5  text-sm leading-6 text-gray-600">
                  {post.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
